export const ROLES = ['SUPER_ADMIN', 'ADMIN', 'ORGANIZATION_ADMIN', 'NATIONAL_USER', 'STATE'];

export const QUESTION_VALUE_TYPE = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
  GRID: 'GRID',
  OPEN_NUMERIC: 'OPEN_NUMERIC',
  OPEN_TEXT: 'OPEN_TEXT',
  GRID_MULTIPLE: 'GRID_MULTIPLE',
  RANK_ORDER: 'RANK_ORDER',
};

export const QUESTION_TYPE = ['NONE', 'DISCRETE', 'RANGEPOSITIVE'];

export const QUESTION_FILTER_TYPE = {
  NONE: 'NONE',
  LOCATION: 'LOCATION',
  ATTRIBUTE: 'ATTRIBUTE',
  QUESTION: 'QUESTION',
};

export const AUTO_SAVING_TIME = 20000;

export const ONBOARDING_STEPS = {
  step1: {
    previous: '',
    value: 'step1',
    title: 'Navigation Sidebar',
    content: `Click on a survey section to see a preview of that section's survey questions and edit their components.`,
  },
  step2: {
    previous: 'step1',
    value: 'step2',
    title: 'Survey Preview',
    content: `Here you can see a preview of the survey element you selected on the left. Click on a question to expand it and select elements to edit.`,
  },
  step3: {
    previous: 'step2',
    value: 'step3',
    title: 'Question Elements',
    content: `Click on a question element to edit it.`,
  },
  step4: {
    previous: 'step3',
    value: 'step4',
    title: 'Managing Filters',
    content: `Select which type of filter the selected survey question will be, or select None to prevent filtering by response to the selected question.`,
    link: `Learn more about filters >`,
  },
  step5: {
    previous: 'step4',
    value: 'step5',
    title: 'Question Color Schemes',
    content: `<p class="text-left"><b>Gradient</b>: For data in an ordered series.</p>
      <p class="text-left"><b>Discrete</b>: For data with no inherent order or rank.</p>
      <p class="text-left"><b>Positive</b>: For data with two ends and a middle, like Likert scale questions.<p/>`,
  },
  step6: {
    previous: 'step5',
    value: 'step6',
    title: 'Saving Changes',
    content: `Click on "Save" to save all the changes made to the question elements and update the survey preview on the right.`,
  },
  step7: {
    previous: 'step6',
    value: 'step7',
    title: 'Previewing Your Changes',
    content: `After saving, your changes are reflected in the survey preview.`,
  },
  step8: {
    previous: 'step7',
    value: 'step8',
    title: 'Saving Changes',
    content: `The changes you make will also save automatically. Click here if you'd like to undo a change.`,
  },
  step9: {
    previous: 'step7',
    value: 'step9',
    title: 'Save & Continue',
    content: `Click here to view your updated draft survey in the Survey Explorer.`,
  },
  step10: {
    previous: '',
    value: 'step10',
    title: 'Filter list',
    content: `Here you can see a list of non-survey question information about your survey respondents, which can be used as filters. Click on a filter to expand it and edit its components.`,
  },
  step11: {
    previous: 'step10',
    value: 'step11',
    title: 'Editing tags',
    content: `Click on a filter tag to edit the display name.`,
  },
  step12: {
    previous: 'step11',
    value: 'step12',
    title: 'Show or Hide tags',
    content: `Click the eye icon to show or hide filter tags from users (for example, you might hide a tag with no responses).`,
  },
  step13: {
    previous: 'step12',
    value: 'step13',
    title: 'Previewing Your Changes',
    content: `After saving, your changes are reflected in the preview pane on the right.`,
  },
};

export const COLOR_SCHEME_ONBOARDING_STEPS = {
  step1: {
    previous: '',
    value: 'step1',
    title: 'Navigation Sidebar',
    content: `Click on a survey section to see a preview of that section's survey questions and edit their components.`,
  },
  step2: {
    previous: 'step1',
    value: 'step2',
    title: 'Survey Preview',
    content: `Here you can see a preview of the survey element you selected on the left. Click on a question to expand it and select elements to edit.`,
  },
  step3: {
    previous: 'step2',
    value: 'step3',
    title: 'Question Elements',
    content: `Click on a question element to edit it.`,
  },
  step4: {
    previous: 'step3',
    value: 'step4',
    title: 'Managing Filters',
    content: `Select which type of filter the selected survey question will be, or select None to prevent filtering by response to the selected question.`,
    link: `Learn more about filters >`,
  },
  step6: {
    previous: 'step4',
    value: 'step6',
    title: 'Saving Changes',
    content: `Click on "Save" to save all the changes made to the question elements and update the survey preview on the right.`,
  },
  step7: {
    previous: 'step6',
    value: 'step7',
    title: 'Previewing Your Changes',
    content: `After saving, your changes are reflected in the survey preview.`,
  },
  step8: {
    previous: 'step7',
    value: 'step8',
    title: 'Saving Changes',
    content: `The changes you make will also save automatically. Click here if you'd like to undo a change.`,
  },
  step9: {
    previous: 'step7',
    value: 'step9',
    title: 'Save & Continue',
    content: `Click here to view your updated draft survey in the Survey Explorer.`,
  },
  step10: {
    previous: '',
    value: 'step10',
    title: 'Filter list',
    content: `Here you can see a list of non-survey question information about your survey respondents, which can be used as filters. Click on a filter to expand it and edit its components.`,
  },
  step11: {
    previous: 'step10',
    value: 'step11',
    title: 'Editing tags',
    content: `Click on a filter tag to edit the display name.`,
  },
  step12: {
    previous: 'step11',
    value: 'step12',
    title: 'Show or Hide tags',
    content: `Click the eye icon to show or hide filter tags from users (for example, you might hide a tag with no responses).`,
  },
  step13: {
    previous: 'step12',
    value: 'step13',
    title: 'Previewing Your Changes',
    content: `After saving, your changes are reflected in the preview pane on the right.`,
  },
};

export const OPEN_TEXT_ONBOARDING_STEPS = {
  step1: {
    previous: '',
    value: 'step1',
    title: 'Navigation Sidebar',
    content: `Click on a survey section to see a preview of that section's survey questions and edit their components.`,
  },
  step2: {
    previous: 'step1',
    value: 'step2',
    title: 'Survey Preview',
    content: `Here you can see a preview of the survey element you selected on the left. Click on a question to expand it and select elements to edit.`,
  },
  step3: {
    previous: 'step2',
    value: 'step3',
    title: 'Question Elements',
    content: `Click on a question element to edit it.`,
  },
  step6: {
    previous: 'step3',
    value: 'step6',
    title: 'Saving Changes',
    content: `Click on "Save" to save all the changes made to the question elements and update the survey preview on the right.`,
  },
  step7: {
    previous: 'step6',
    value: 'step7',
    title: 'Previewing Your Changes',
    content: `After saving, your changes are reflected in the survey preview.`,
  },
  step8: {
    previous: 'step7',
    value: 'step8',
    title: 'Saving Changes',
    content: `The changes you make will also save automatically. Click here if you'd like to undo a change.`,
  },
  step9: {
    previous: 'step7',
    value: 'step9',
    title: 'Save & Continue',
    content: `Click here to view your updated draft survey in the Survey Explorer.`,
  },
  step10: {
    previous: '',
    value: 'step10',
    title: 'Filter list',
    content: `Here you can see a list of non-survey question information about your survey respondents, which can be used as filters. Click on a filter to expand it and edit its components.`,
  },
  step11: {
    previous: 'step10',
    value: 'step11',
    title: 'Editing tags',
    content: `Click on a filter tag to edit the display name.`,
  },
  step12: {
    previous: 'step11',
    value: 'step12',
    title: 'Show or Hide tags',
    content: `Click the eye icon to show or hide filter tags from users (for example, you might hide a tag with no responses).`,
  },
  step13: {
    previous: 'step12',
    value: 'step13',
    title: 'Previewing Your Changes',
    content: `After saving, your changes are reflected in the preview pane on the right.`,
  },
};

export const SURVEY_FILTERS = {
  AME: 'AMES',
  AIR: 'AIRS',
  SDC: 'ASDP',
  AYP: 'AYP',
  LTS: 'LTS',
};

export const SURVEY_FILTER_LIST = ['AME', 'AIR', 'SDC', 'AYP', 'LTS'];
